import { FormattedMessage } from 'react-intl';
import { PropTypes } from 'prop-types';

import HeroOverlay from './HeroOverlay';
import * as UI from '../../ui';
import loadable from '@loadable/component';

import { useFelaEnhanced } from '@ackee/fela';
import * as felaRules from './HeroSection.styles';
import ClientsSection from '../../clients/ClientsSection';

import React, { useRef } from 'react';

const { DynamicContainer, Title, TitleTypes, Text } = UI;
const ModelLogo = loadable(() => import('./../../3d/Models/SusLogo'));

const HeroSection = ({ reference }) => {
    const { styles, rules } = useFelaEnhanced(felaRules);
    const containerRef = useRef();

    return (
        <div ref={containerRef}>
            <DynamicContainer extend={{ container: rules.extendMainContainer }} ref={reference}>
                <HeroOverlay />

                <DynamicContainer extend={{ container: rules.fluidContainer }} columns={12} type={'grid'}>
                    <DynamicContainer columns={8} startAt={6}>
                        <ModelLogo mousePositionContainer={containerRef} />
                    </DynamicContainer>
                </DynamicContainer>

                <div className={styles.contentContainer}>
                    <Title
                        extend={{ title: rules.extendTitle }}
                        type={TitleTypes.H1_ITALIC_UPPERCASE}
                        as={TitleTypes.H1}
                    >
                        <FormattedMessage id="homepage.hero.title" />
                    </Title>
                    <Text extend={{ text: rules.extendText }}>
                        <FormattedMessage id="homepage.hero.description" />
                    </Text>
                </div>
                <ClientsSection />
            </DynamicContainer>
        </div>
    );
};

HeroSection.propTypes = {
    reference: PropTypes.shape().isRequired,
};

export default HeroSection;
